






















































































































import Vue from 'vue'
import Component from "vue-class-component"
import _, { Function } from "lodash"
import {Prop, Ref, Watch} from "vue-property-decorator"
import {Getter, State} from "vuex-class"
import User from "@/modules/user/model/User"
import PostalCodeSearch from "@/modules/geo/components/PostalCodeSearch.vue"
import Form from "@/components/Form.vue"
import {Colors, notify} from "@/modules/core/notification";

/**
 * Información del usuario
 *
 * Muestra los campos principales que guardan la información del usuario.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {PostalCodeSearch}
})
export default class UserInfo extends Vue {
    /**
     * Indica si el formulario es válido
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Usuario en edición cargado desde el estado de la aplicación
     */
    @State(state => state.user.currentUser)
    public user: User

    @Ref('form')
    public form: Form

   /**
    * Comprueba si el módulo argumentado se encuentra activo en la aplicación
    */
    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean
    
    created(){
        // Si es nuevo el usuario y tiene el modulo app-router cuando se crea un
        // usario nuevo desde el panel enrutador lo pone como verificado ya que 
        // el administrador del panel es cociente que crear un usuario real/verifcado.
        this.user.verified = this.isVerifiedByDefault;
    }
    /**
     * Indica si el correo electrónico se encuentra disponible para ser registrado
     */
    public emailAvailable = true

    public newPassword = ''
    public newPasswordConfirm = ''

    public get checkingEmailAvailability () {
        return this.$store.state.user.checkingEmailAvailability
    }

    public set checkingEmailAvailability (value: boolean) {
        this.$store.commit('user/TOGGLE_CHECKING_EMAIL_AVAILABILITY', value)
    }

    /**
     * Ejecuta la validación de formulario
     */
    public validate () {
        return this.form.validate()
    }

    /**
     * Restablece la validación de los campos del formulario
     */
    public resetValidation () {
        this.form.resetValidation()
    }

    @Watch('user.updatedEmail')
    public onEmailChange (email: string) {
        this.checkEmailDebounce(email)
    }

    /**
     * Reglas de validación para el formulario de edición del usuario.
     *
     * Reglas:
     * - La dirección de correo es obligatoria, debe tener un formato válido y que ningún otro
     *   usuario la este utilizando
     * - La contraseña no puede estar vacía y debe coinciden con la confirmación
     */
    public get userValidationRules () {
        return {
            email: [
                (v: string) => !!v || 'El correo electrónico no puede estar vacío',
                (v: string) => {
                    const r = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return r.test(v) || 'El formato del correo no es válido'
                },
                (v: string) => this.emailAvailable || 'El correo electrónico no esta disponible',
            ],
            password: [
                (v: string) => !!v || 'La nueva contraseña no puede estar vacía',
            ],
            passwordConfirm: [
                (v: string) => !!v || 'La confirmación de contraseña es obligatoria',
                // (v: string) => ((this.user.isNew ? this.user.newPassword : this.newPassword) === v || 'La contraseña no coincide'),
            ],
        }
    }

    clipboardWrite (text: string) {
        const notifyCopy = () => notify('Se ha copiado el ID del usuario', Colors.Success, { notShowInCenter: true })

        // El navegador soporta la API Clipboard
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => notifyCopy())

            return
        }

        const textarea = document.createElement('textarea')
        textarea.textContent = text
        textarea.style.position = 'fixed'
        document.body.appendChild(textarea)
        textarea.select();

       try {
           document.execCommand('copy')
           notifyCopy()
       } catch (error) {
            console.error(error)
       } finally {
           document.body.removeChild(textarea);
       }
    }


    /**
     * Comprobar disponibilidad de email
     *
     * Método invocado por el Watcher que escucha la propiedad "user.email" para comprobar
     * si el correo se encuentra disponible y si no notificar al usuario.
     *
     * El método se ejecuta con un rebote de 500ms, solo se ejecutará cuando
     * el usuario haya estado mas de 500 milisegundo sin introducir
     * texto en el campo del correo electrónico
     */
    public checkEmailDebounce = _.debounce(async function (this: UserInfo, email: string) {
        if (this.user.email === this.user.updatedEmail) {
            this.emailAvailable = true

            return
        }

        this.checkingEmailAvailability = true
        this.emailAvailable = await this.$store.dispatch('user/checkEmailAvailability', email)
        this.checkingEmailAvailability = false

        // Solicita al formulario la revalidación de los campos
        this.form.validate()
    }, 500)

    mounted(){
        //autofocus    
       /* if(this.user.isNew){
           setTimeout(()=>{
               //const emailField = (this.$refs.email as any).$el;
               //emailField.focus();
               ////(this.$refs["email"] as HTMLElement).focus();
               const emailField = ((this.$refs["email"] as any).$el as HTMLInputElement);
               emailField.focus();
           }, 200);
       } */
    }

    /**
     * Si es nuevo el usuario y tiene el modulo app-router cuando se crea un
     * usario nuevo desde el panel del enrutador lo pone como verificado ya que 
     * el administrador del panel es cociente que crear un usuario real/verifcado, si no es nuevo el que tenga asignado.
     * Si no tiene le módulo devuelve en caso nuevo o ya creado el valor que tenga asignado, vamos falso cuando es Nuevo y
     * el valor que tenga cuando ya está creado.
    */
    public get isVerifiedByDefault() {
        if(this.user.isNew){
            return (this.moduleIsEnabled('app-router') && this.user.isNew);
        }
        else {
            return this.user.verified;
        }
    }
    
    generatePassword(){
        const password = this.generateRandomPassword(8);
        this.user.newPassword = password;
        this.newPasswordConfirm = password;
    }

    generateRandomPassword(length:number) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const specialChars = "!.$";
    let password = "";

    // Añadir al menos un carácter especial
    password += specialChars[Math.floor(Math.random() * specialChars.length)];

    // Generar el resto de la contraseña
    for (let i = 1; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }

    // Mezclar la contraseña para que los caracteres especiales no estén al final
    password = this.shuffleString(password);

    return password;
  }
  
  shuffleString(value:string) {
    const array = value.split("");
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array.join("");
  }
}
